import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message! We\'ll get back to you within 24 hours.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <h1 className="page-title font-heading">Get In Touch</h1>
          <p className="page-subtitle">Questions? Ready to book? We're here to help.</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="contact-heading font-heading">Contact Information</h2>
              
              <div className="info-item">
                <div className="info-icon"><Phone size={20} strokeWidth={1.5} /></div>
                <div className="info-details">
                  <h3>Phone</h3>
                  <p>(424) 485-1880</p>
                  <small>Mon-Sun 8AM-8PM</small>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon"><Mail size={20} strokeWidth={1.5} /></div>
                <div className="info-details">
                  <h3>Email</h3>
                  <p>info@lavacomanagement.com</p>
                  <small>We reply within 24 hours</small>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon"><MapPin size={20} strokeWidth={1.5} /></div>
                <div className="info-details">
                  <h3>Service Area</h3>
                  <p>Los Angeles, CA</p>
                  <small>& surrounding areas</small>
                </div>
              </div>

              <div className="quick-book">
                <h3>Ready to book?</h3>
                <p>Skip the contact form and get your quote in minutes</p>
                <Link to="/book" className="btn btn-primary">
                  Book Now
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </Link>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <h2 className="contact-heading font-heading">Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Your Name</label>
                  <input
                    type="text"
                    className="form-input"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-input"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Phone</label>
                  <input
                    type="tel"
                    className="form-input"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Message</label>
                  <textarea
                    className="form-textarea"
                    rows="5"
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-large">
                  Send Message
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
